import React from 'react';
import OrderReport from '../../components/Organization/View Distribution/OrderReport';

export const OrdersList: React.FC = () => {
  return (
    <div className=" animate-fadeIn">
      {/* Top Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-2">
        <div>
          <h1 className="text-2xl font-black text-[#C62828] tracking-tight m-0">
            Orders Management
          </h1>
          <p className="text-xs text-slate-500 mt-1 m-0">
            View and manage distributor orders across zones and cities
          </p>
        </div>
      </div>

      {/* Main Filterable Orders Content */}
      <OrderReport />
    </div>
  );
};

export default OrdersList;
